"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOKENS = exports.TYPES = void 0;
var TYPES = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  CRITICAL: "critical"
};
exports.TYPES = TYPES;
var TOKENS = {
  background: "background",
  backgroundHover: "backgroundHover",
  backgroundActive: "backgroundActive",
  foreground: "foreground",
  foregroundHover: "foregroundHover",
  foregroundActive: "foregroundActive",
  marginRightIcon: "marginRightIcon"
};
exports.TOKENS = TOKENS;